export default __webpack_public_path__ + "static/media/league-img.173241f5.png";